import gql from 'graphql-tag';

export default gql`
mutation PreviewApp(
        $uuid: String!
      ) {
    previewApp(input:{
        uuid: $uuid
    }) {
      __typename
    }
}
`;
